import React from 'react';
import {NavLink as Link, useLocation} from 'react-router-dom';


export default ({
  toc,
  ...props
}) => {
  const location = useLocation();
  const minified = location.search.includes('mode=player');
  return (
    <nav className={`${minified ? 'is-minified': ''}`}>
      <div className="vertical-line" />
      <Link exact activeClassName="hidden"  className={`title`} to="/"><h1>Enquête sur EME</h1></Link>
      <ul>
        {
          toc.map((el, index) => (
            <li key={index}>
              <Link exact activeClassName="active" to={el.path}>
                <span>{el.parameters.title}</span>
              </Link>
            </li>
          ))
        }
      </ul>
    </nav>
  )
}